import { useStore } from '../../FronteggStoreContext';
import { useSnapshot } from '../../useSnapshot';
export function useSessionsPolicyState() {
  const state = useStore().store.auth.sessionsPolicyState;
  return useSnapshot(state);
}
export const useSessionsPolicyActions = () => {
  return useStore().stateActions.auth.sessionsPolicyActions;
};